export class Notice {
  key: number;
  title: string;
  content: string;
  blocks: string[];
  linkLabel: string;
  linkUrl: string;
  thumbImage?: string;

  isLeftZone?: boolean;
  isRightZone?: boolean;

  constructor(
    title: string,
    content: string,
    blocks: string[],

    linkUrl?: string,
    linkLabel?: string,
    key?: number,
    thumbImage?: string

  ) {
    this.title = title;
    this.content = content;
    this.blocks = blocks;

    if (linkUrl) { this.linkUrl = linkUrl; }
    if (linkLabel) { this.linkLabel = linkLabel; }
    if (key) { this.key = key; }
    if (thumbImage) { this.thumbImage = thumbImage; }
  }
}

// export class Block {
//   content_left: string;
//   content_right: string;
// }

export class TopBlock {
  block: string;
  content?: string;
  thumbImage?: string;
}
